module.exports = __webpack_public_path__ + "img/but_page_icon25.1b82c688.png";